export const phone = {
  required: true,
  numeric: true,
  max: 15,
};

export const authorizedUser = {
  required: true,
  max: 35
};

export const company = {
  required: true,
  max: 35
};

export const productType = {
  required: true,
  max: 35
}

export const getPostalCodeRules = (extraRules = null) => {
  let rules = {
    required: true,
    max: 9,
    alpha_num: true
  };

  if(extraRules){
    rules = {
      ...rules,
      ...extraRules
    };
  }

  return rules;
}

/**
 * This is for customer reference input rules.
 * @param {string} referenceText 
 * @returns 
 */
export const getLabelCustomerReferenceRules = (referenceText, selectedLogisticsCompany = null) => {
  if (!referenceText || !selectedLogisticsCompany) return '';
  if (selectedLogisticsCompany === 'UPS') {
    const isNumeric = /^[0-9]+$/.test(referenceText);
    if (isNumeric) {
      return 'max:24|maxWords:1';
    } else {
      return 'max:14|maxWords:1';
    }
  } else {
    return 'max:30|maxWords:1';
  }
}

export default {
    phone,
    authorizedUser,
    company,
    productType,
    getLabelCustomerReferenceRules
};

